export function generateID(length) {
  let result = '';
  const characters =
    'ABCDEFGHIJKLMNOPQRSTUVWXYZ' + 'abcdefghijklmnopqrstuvwxyz0123456789';
  const charactersLength = characters.length;
  for (let i = 0; i < length; i++) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength));
  }
  return result;
}

export function generateDefault(data) {
  return Object.assign(
    {
      id: generateID(5) + new Date().getTime() + hashCode(JSON.stringify(data))
    },
    data
  );
}

export function hashCode(s) {
  return s.split('').reduce(function(a, b) {
    a = (a << 5) - a + b.charCodeAt(0);
    return a & a;
  }, 0);
}



/** WEBPACK FOOTER **
 ** ./~/kaistore-post-messenger/lib/utils.js
 **/